// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"NonDisclosureToolTipWarning_buttonWrapper__+c33t","divider":"NonDisclosureToolTipWarning_divider__EFOZv"};